export default function ModalScreen() {
  return null
}
